export default "__VITE_ASSET__CgEMe7rH__"